

























































import { defineComponent, toRefs } from '@vue/composition-api';
import AtoneAlert from '@berlin-front/common/components/atone-components/AtoneAlert';
import AppButton from '@berlin-front/common/components/elements/AppButton';
import AppCard from '@berlin-front/common/components/elements/AppCard';
import AppContainer from '@berlin-front/common/components/elements/AppContainer';
import AttributeList from '@berlin-front/common/components/elements/AttributeList';
import AttributeName from '@berlin-front/common/components/elements/AttributeName';
import AttributeValue from '@berlin-front/common/components/elements/AttributeValue';
import AppMessageList from '@berlin-front/common/components/elements/AppMessageList';
import AppProgressBar from '@berlin-front/common/components/elements/AppProgressBar';
import AppRow from '@berlin-front/common/components/elements/AppRow';
import AppText from '@berlin-front/common/components/elements/AppText';
import ModalHeader from '@berlin-front/common/components/clusters/ModalHeader';
import { useContext } from '@berlin-front/common/composables/context';
import { ModalHeaderContext } from '@services/ModalHeaderContext';
import { LINE_HEIGHT, TEXT_WEIGHT } from '@berlin-front/common/components/elements/AppText/composable';
import { HEIGHT_TYPE } from '@berlin-front/common/components/elements/AppProgressBar/composable';
import { formatTelNumber } from '@berlin-front/common/utils';
import { AuthMemberConfirmContext } from './context';

export default defineComponent({
  name: 'AuthMemberConfirmView',
  components: {
    AtoneAlert,
    AppButton,
    AppCard,
    AppContainer,
    AppMessageList,
    AppProgressBar,
    AppRow,
    AppText,
    AttributeList,
    AttributeName,
    AttributeValue,
    ModalHeader,
    HeaderContextConsumer: ModalHeaderContext.consumer,
  },

  setup() {
    const { useMemberConfirm } = useContext(AuthMemberConfirmContext);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
    const { member, messages, progress, sendSmsCode, editMemberInfo } = toRefs(useMemberConfirm());

    return {
      member,
      messages,
      progress,

      sendSmsCode,
      editMemberInfo,

      formatTelNumber,

      HEIGHT_TYPE,
      TEXT_WEIGHT,
      LINE_HEIGHT,
    };
  },
});
